// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2SebZ","buttons":"RemoveExpirationActionButtons_buttons__1BwWD"};